import { useEventsSubscriber } from 'event-bus';
import { CLIENT_APP_INVITATION_SENT } from 'nekst-api';
import { toastService } from './toastService';

export default function ClientAppInvitationEventsToasts() {
  useEventsSubscriber(
    'ClientAppInvitationEventsToasts',
    {
      [CLIENT_APP_INVITATION_SENT]: () => {
        toastService.createToast('Invitation sent successfully');
      },
    },
    []
  );

  return null;
}
